import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMarker, IVideoElementSizeInfo, IPlayList, IWebListConfig, IDetails, IVideoDataSlice, ISubtitleColor } from "../../interfaces/interfaces";

export const VideoDataSliceState: IVideoDataSlice = {
    details: {
        stream_link: "",
        type: "",
        banner: "",
        id: undefined,
        title: undefined,
        description: undefined,
        viewers: undefined,
        live_viewers: undefined,
        like: undefined,
        start_time: undefined,
        tag: undefined,
        subtitles: undefined,
        vtt: undefined,
        vtt_mobile: undefined,
        preview_start: null,
        preview_end: null,
        download_links: [],
        pg_state: null,
        user_id: null,
        online_viewer_threshold: 0,
        content_id: undefined,
        content_type: null,
        imdb_rate: null,
        release_year: null,
        duration: 0
    },
    params: {
        src: "",
        type: "",
        id: "",
        fullscreen: "",
        autoplay: "",
        portrait: "",
        t: "",
        h: "",
        isGeneral: "",
        raw: "",
        theme: "dark",
        provider: "unknown",
        fullrate: "false",
        snapshot: "false",
        cover: "",
        user_id: "",
        user_ids: "",
        preview: "false",
        isAuth: "false",
        authentication: "true",
        site: "",
        "e-url": "",
        "e-cover": "",
        width: "",
        height: "",
        chart: "false",
        onFinished: undefined,
        showModuleTitle: "false",
        scrollElementId: undefined,
        onSnapshot: undefined,
        isMarkersChange: false,
        quiz: "false",
        featureSet: undefined,
        uuid: "",
        homeButtonClickFlag: undefined
    },
    streamLinkParams: "",
    markers: [],
    liveId: undefined,
    vodId: undefined,
    onlineViewers: undefined,
    question: undefined,
    options: undefined,
    selectedOptionId: null,
    emojis: undefined,
    alternative_Lives: [],
    config: undefined,
    isLiveError: true,
    emojiList1: [],
    emojiList2: [],
    gif: null,
    multiLives: [],
    multiAudio: [],
    selectedAudioId: 0,
    subtitles: [],
    selectedSubtitle: undefined,
    subtitleText: undefined,
    isComplexPortrait: undefined,
    isComplexDesktop: false,
    videoElementSizeInfo: {
        bottom: 0,
        top: 0,
        right: 0,
        left: 0,
        width: 0,
        height: 0
    },
    recommendationList: undefined,
    token: "",
    isFetchDetails: false,
    isValidAddress: false,
    playList: undefined,
    videoTimelines: [],
    webListConfig: [],
    chartPoints: [],
    isReady: false,
    showScreen: false,
    trailer: [],
    hlsLiveSyncPosition: 0
};

export const videoDataSlice = createSlice({
    name: "videoData",
    initialState: VideoDataSliceState,
    reducers: {
        setInfo: (state, action: PayloadAction<IDetails>) => {
            state.details = action.payload;
        },
        setPlayerParams: (state, action: PayloadAction<any>) => {
            state.params = action.payload;
        },
        setStreamLinkParams: (state, action: PayloadAction<string>) => {
            state.streamLinkParams = action.payload;
        },
        setMarkers: (state, action: PayloadAction<IMarker[]>) => {
            state.markers = action.payload;
        },
        setLiveId: (state, action: PayloadAction<number>) => {
            state.liveId = action.payload;
        },
        setVodId: (state, action: PayloadAction<number>) => {
            state.liveId = action.payload;
        },
        setOnlineViewers: (state, action: PayloadAction<any>) => {
            state.onlineViewers = action.payload;
        },
        setQuestion: (state, action: PayloadAction<any>) => {
            state.question = action.payload;
        },
        setSelectedOptionId: (state, action: PayloadAction<number | null>) => {
            state.selectedOptionId = action.payload;
        },
        setEmojis: (state, action: PayloadAction<any>) => {
            state.emojis = action.payload;
        },
        setAlternative_Lives: (state, action: PayloadAction<number[]>) => {
            state.alternative_Lives = action.payload;
        },
        setConfig: (state, action: PayloadAction<any>) => {
            state.config = action.payload;
        },
        setIsLiveError: (state, action: PayloadAction<boolean>) => {
            state.isLiveError = action.payload;
        },
        setEmojiList1: (state, action: PayloadAction<string[]>) => {
            state.emojiList1 = action.payload;
        },
        setEmojiList2: (state, action: PayloadAction<string[]>) => {
            state.emojiList2 = action.payload;
        },
        setGif: (state, action: PayloadAction<string | null>) => {
            state.gif = action.payload;
        },
        setErrorType: (state, action: PayloadAction<string | undefined>) => {
            state.errorType = action.payload;
        },
        setMultiLives: (state, action: PayloadAction<any[]>) => {
            state.multiLives = action.payload;
        },
        setMultiAudio: (state, action: PayloadAction<any>) => {
            state.multiAudio = JSON.parse(JSON.stringify(action.payload));
        },
        setSelectedAudioId: (state, action: PayloadAction<number>) => {
            state.selectedAudioId = action.payload;
        },
        setSubtitles: (state, action: PayloadAction<any>) => {
            state.subtitles = action.payload;
        },
        setSelectedSubtitle: (state, action: PayloadAction<any>) => {
            state.selectedSubtitle = action.payload;
        },
        setSubtitleText: (state, action: PayloadAction<string>) => {
            state.subtitleText = action.payload;
        },
        setIsComplexPortrait: (state, action: PayloadAction<boolean>) => {
            state.isComplexPortrait = action.payload;
        },
        setIsComplexDesktop: (state, action: PayloadAction<boolean>) => {
            state.isComplexDesktop = action.payload;
        },
        setVideoElementSizeInfo: (state, action: PayloadAction<IVideoElementSizeInfo>) => {
            state.videoElementSizeInfo = action.payload;
        },
        setRecommendationList: (state, action: PayloadAction<any>) => {
            state.recommendationList = action.payload;
        },
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
        },
        setIsFetchDetails: (state, action: PayloadAction<boolean>) => {
            state.isFetchDetails = action.payload;
        },
        setIsValidAddress: (state, action: PayloadAction<boolean>) => {
            state.isValidAddress = action.payload;
        },
        setPlayList: (state, action: PayloadAction<IPlayList[]>) => {
            state.playList = action.payload;
        },
        setVideoTimelines: (state, action: PayloadAction<number[]>) => {
            state.videoTimelines = action.payload;
        },
        setWebListConfig: (state, action: PayloadAction<IWebListConfig[]>) => {
            state.webListConfig = action.payload;
        },
        setChartPoints: (state, action: PayloadAction<number[]>) => {
            state.chartPoints = action.payload;
        },
        setIsReady: (state, action: PayloadAction<boolean>) => {
            state.isReady = action.payload;
        },
        setShowScreen: (state, action: PayloadAction<boolean>) => {
            state.showScreen = action.payload;
        },
        setTrailer: (state, action: PayloadAction<any[]>) => {
            state.trailer = action.payload;
        },
        setClearVideoDataSlice: (state) => {
            return (state = VideoDataSliceState);
        }
    }
});

export const {
    setInfo,
    setPlayerParams,
    setStreamLinkParams,
    setMarkers,
    setLiveId,
    setVodId,
    setOnlineViewers,
    setQuestion,
    setSelectedOptionId,
    setEmojis,
    setAlternative_Lives,
    setConfig,
    setIsLiveError,
    setEmojiList1,
    setEmojiList2,
    setGif,
    setErrorType,
    setMultiLives,
    setMultiAudio,
    setSelectedAudioId,
    setSubtitles,
    setSelectedSubtitle,
    setSubtitleText,
    setIsComplexPortrait,
    setIsComplexDesktop,
    setVideoElementSizeInfo,
    setRecommendationList,
    setToken,
    setIsFetchDetails,
    setIsValidAddress,
    setPlayList,
    setVideoTimelines,
    setWebListConfig,
    setChartPoints,
    setIsReady,
    setClearVideoDataSlice,
    setShowScreen,
    setTrailer
} = videoDataSlice.actions;
export default videoDataSlice.reducer;
